import React, { useEffect, useRef, useState } from 'react';
import { Volume2, Square, Loader2 } from 'lucide-react';
import { api, apiUrl } from '../lib/api';
import { toast } from 'sonner';

let current = null;
export const stopSpeaking = () => {
  if (!current) return;
  const a = current; current = null;
  a.onended = null; a.onerror = null;
  a.pause(); a.src = '';
};

export const SpeakButton = ({ text, label, autoPlay = false, testid = 'speak-btn', voiceOverride, onEnd }) => {
  const [state, setState] = useState('idle');
  const audioRef = useRef(null);
  const endRef = useRef(onEnd);
  endRef.current = onEnd;

  const play = async () => {
    if (state === 'playing') { stopSpeaking(); setState('idle'); return; }
    setState('loading');
    try {
      const { url } = await api.tts(text, voiceOverride || localStorage.getItem('aurra_voice') || 'nova');
      stopSpeaking();
      const a = new Audio(apiUrl(url));
      a.crossOrigin = 'use-credentials';
      audioRef.current = a; current = a;
      a.onended = () => { setState('idle'); if (current === a) current = null; endRef.current?.(); };
      a.onpause = () => setState('idle');
      a.onerror = () => { setState('idle'); toast.error('Lecture audio impossible'); endRef.current?.(); };
      await a.play();
      setState('playing');
    } catch (e) { setState('idle'); toast.error(e.message || 'Synthèse vocale impossible'); endRef.current?.(); }
  };

  const playedRef = useRef(false);
  useEffect(() => { if (autoPlay && text && !playedRef.current) { playedRef.current = true; play(); } }, [autoPlay]); // eslint-disable-line
  useEffect(() => () => { if (audioRef.current && current === audioRef.current) stopSpeaking(); }, []);

  return (
    <button data-testid={testid} onClick={play} className={`text-xs flex items-center gap-1 hover:text-foreground ${state === 'playing' ? 'text-primary' : 'text-muted-foreground'}`}>
      {state === 'loading' ? <Loader2 className="h-3 w-3 animate-spin" /> : state === 'playing' ? <Square className="h-3 w-3" /> : <Volume2 className="h-3 w-3" />} {label}
    </button>
  );
};
